import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { fetchUserProfile, SERVER_URL } from "../utils/api"; 
import { useNavigate } from "react-router-dom"; // ✅ IMPORT USENAVIGATE
import ChatList from "../components/ChatList";
import PreviousRides from "../components/PreviousRides";
import BookedRides from "../components/BookedRides";
import AnimatedLogout from "../components/AnimatedLogout"; 
import ProfileProgress from "../components/ProfileProgress";
import AdBanner from "../components/ads/AdBanner"; 

import "../css/profile.css";

export default function ProfileDashboard() {
  const { user: contextUser, clearUser, token } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("profile");
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const navigate = useNavigate(); // ✅ INITIALIZE NAVIGATE

  useEffect(() => {
    const loadLatestProfile = async () => {
      const userId = contextUser?.id || contextUser?._id;
      if (!userId || !token) { setLoading(false); return; }
      try {
        const freshData = await fetchUserProfile(userId, token);
        setProfileData(freshData.user || freshData);
      } catch (err) {
        setProfileData(contextUser);
      } finally { setLoading(false); }
    };
    loadLatestProfile();
  }, [contextUser, token]);

  if (loading) return (
    <div className="pd-loading-screen">
      <div className="pd-loader"></div>
      <p>Syncing Vyango Data...</p>
    </div>
  );

  if (!contextUser) return <div className="pd-no-auth">Access Denied. Please Login.</div>;

  const displayUser = profileData || contextUser;
  const avatarURL = displayUser.avatar 
    ? (displayUser.avatar.startsWith("http") ? displayUser.avatar : `${SERVER_URL}${displayUser.avatar}`)
    : "/default-avatar.png";
  
  const userRating = Number(displayUser.rating) || 0;
  const totalReviews = Number(displayUser.totalRatings) || 0;

  return (
    <div>
       <ProfileProgress />
    <div className="pd-layout">
      {/* --- Modern Floating Sidebar (Clean, NO ADS HERE) --- */}

     
      <aside className="pd-sidebar">
        <div className="pd-sidebar-header">
          <h2>Vyango</h2>
        </div>
        <div className="pd-menu">
          <button onClick={() => setActiveTab("profile")} className={activeTab === "profile" ? "active" : ""}>
            <span className="pd-menu-icon">👤</span> My Account
          </button>
          <button onClick={() => setActiveTab("rides")} className={activeTab === "rides" ? "active" : ""}>
            <span className="pd-menu-icon">🚗</span> Shared History
          </button>
          <button onClick={() => setActiveTab("booked")} className={activeTab === "booked" ? "active" : ""}>
            <span className="pd-menu-icon">🎟️</span> My Bookings
          </button>
          <button onClick={() => setActiveTab("chat")} className={activeTab === "chat" ? "active" : ""}>
            <span className="pd-icon">💬</span> Chat
          </button>
        </div>

        <AnimatedLogout onLogout={clearUser} />
      </aside>

      {/* --- Premium Main Panel --- */}
      <main className="pd-content">
        {activeTab === "profile" && (
          <div className="pd-profile-view fade-in">
            {/* Elegant Header Area */}
            <div className="pd-hero-section">
              <div className="pd-cover-photo"></div>
              <div className="pd-profile-header">
                <img className="pd-avatar-main" src={avatarURL} alt="User" />
                <div className="pd-header-text">
                  <h1>{displayUser.name}</h1>
                  <div className="pd-rating-container">
                    <span className="pd-star-filled">★</span>
                    <strong>{userRating.toFixed(1)}</strong>
                    <span className="pd-review-count">({totalReviews} reviews)</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Information Cards */}
            <div className="pd-info-cards">
              <div className="pd-card">
                <div className="pd-card-header">
                  <h3>Contact Information</h3>
                  {/* ✅ CHANGED: Now navigates to the full screen page */}
                  <button onClick={() => navigate("/profile/edit")} className="pd-edit-btn">Edit</button>
                </div>
                <div className="pd-card-body">
                  <div className="pd-data-row">
                    <span className="pd-label">Email</span>
                    <span className="pd-value">{displayUser.email}</span>
                  </div>
                  <div className="pd-data-row">
                    <span className="pd-label">Phone</span>
                    <span className="pd-value">{displayUser.phone}</span>
                  </div>
                  <div className="pd-data-row">
                    <span className="pd-label">Address</span>
                    <span className="pd-value">{displayUser.address || "No address saved"}</span>
                  </div>
                </div>
              </div>

              <div className="pd-card">
                <div className="pd-card-header">
                  <h3>Personal & Vehicle</h3>
                </div>
                <div className="pd-card-body">
                  <div className="pd-data-row">
                    <span className="pd-label">Birth Date</span>
                    <span className="pd-value">{displayUser.dob ? new Date(displayUser.dob).toLocaleDateString('en-GB') : "Not set"}</span>
                  </div>
                  <div className="pd-data-row">
                    <span className="pd-label">Gender</span>
                    <span className="pd-value">{displayUser.gender || "Not set"}</span>
                  </div>
                  <div className="pd-data-row">
                    <span className="pd-label">Vehicle</span>
                    <span className="pd-value pd-highlight-text">{displayUser.vehicle || "No vehicle added"}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* PERFECTLY PLACED AD */}
            <div style={{ marginTop: "40px", paddingBottom: "20px" }}>
              <AdBanner type="inline" />
            </div>

          </div>
        )}

        {/* Existing Tab Components */}
        {/* ✅ REMOVED the old edit tab from here */}
        {activeTab === "rides" && <PreviousRides user={displayUser} />}
        {activeTab === "booked" && <BookedRides user={displayUser} />}
        {activeTab === "chat" && <ChatList />}
      </main>
    </div>

    </div>
  );
}